import React from 'react'

import crypto from "../../assets/crypto1.png";


function CryptoPay() {
  return (
    <>
    <div className="pt-0 lg:pt-28" />
   
    <div className='w-full flex justify-center items-center bg-black text-white py-8'>
        <img  src={crypto} alt="Coinbase Logo"  className='imageee'/>
    </div>
     </>
  )
}

export default CryptoPay